// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const threadnotificationserviceClient = createTypedClient();
export const createThreadnotificationserviceClient = (config) => createTypedClient(config);
